


















































import Vue from 'vue';

import length from '@turf/length';

import { accessToken } from "@/api/mapbox";

import MapMarker from "./MapMarker.vue";
import MapTrack from "./MapTrack.vue";
import LocationTrack from "./LocationTrack.vue";
import HeightCurve from "./HeightCurve.vue";
import LocationButton from "./LocationButton.vue";
import EditTools from "./EditTools.vue";
// import LayerView from "./LayerView.vue";
import PanZoomInfo from "./PanZoomInfo.vue";
import TrackDescription from "./TrackDescription.vue";

import { checkGeolocationSupport, sendResizeEventNextTick } from "../utils/Utils"

import screenfull from 'screenfull';


import mapboxgl, { Map, LngLatLike, LngLatBounds, CameraOptions, AttributionControl, NavigationControl, GeolocateControl } from 'mapbox-gl';

import {getAutoMarkers, getKmMarkersAlong, updateMarkerProgress} from "@/Util";
import { FeatureCollection, Feature, LineString, Point, Geometry, lineString } from '@turf/helpers';
import * as loc from '@/RunnerLocation';
import { mapGetters } from 'vuex';


export default Vue.extend({

	components: {
		MapMarker,
		MapTrack,
		LocationTrack,
		HeightCurve,
		LocationButton,
		// LayerView,
		PanZoomInfo,
		TrackDescription,
		EditTools,
	},

	data() {
		return {
			progress: 1,
			progressMode: "",
			/*raceLength: 42.195/2,*/
			initialized: false,
			fullscreen: false,
			currentArea: "",
			elWidth: 0,
			currentZoom: 0,

			trackingLocation: false,
			hasGeolocationSupport: false,
		}
	},

	props: {
		styleId: {
			type: String,
			default: "cknzy2s230z2217od6hg1pcdm",
		},

		editMode: {
			type: Boolean,
			default: false,
		}
	},

	computed: {
		allMarkers():Feature[] {
			//@ts-ignore
			return [...this.kmMarkers, ...this.autoMarkers]
		},

		kmMarkers():Feature[] {
			return getKmMarkersAlong(this.trackFeature, 1).features;
		},
		
		autoMarkers():Feature[] {
			return getAutoMarkers(this.trackFeature, this.trackLength);
		},

		iframed() : boolean {
			// https://stackoverflow.com/a/326076
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
    }
		},

		maySwitchToFullscreen() : boolean {
			return screenfull.isEnabled || this.iframed;
		},

		allowAllInteractions() : boolean {
			return this.fullscreen || !this.iframed;
		},

		sizeClass() {
			if(this.elWidth > 1200)
				return "size-l";
			else
				return "size-m" //todo: more sizes
		},

		locationProgress() : number {
			return loc.locationStore.locationProgress;
		},

		...mapGetters(["trackFeature", "trackLength", "heightData"])
	},
	
	provide() {
		const self = this;
		return {
			get $map(){
				return self.$map;
			},
		}
	},

	methods: {
		toggleFullscreen() {

			if(screenfull.isEnabled) {
				screenfull.toggle(this.$refs.mapContainer as HTMLElement);
			} else {
				window.open(window.location.href, "_blank");
			}

		},

		initInteractions() {
			const map = this.$map;
			map.scrollZoom.disable();
			map.touchZoomRotate.disableRotation();
			map.dragRotate.disable();

			map.on("wheel", event => {
				if (event.originalEvent.ctrlKey || this.allowAllInteractions) {
					event.originalEvent.preventDefault(); // Prevent chrome/firefox default behavior
					if (!map.scrollZoom.isEnabled()) {
						map.scrollZoom.enable();
					}
				} else {
					//@ts-ignore
					this.$refs.panZoomInfo.show();
					if (map.scrollZoom.isEnabled()) {
						map.scrollZoom.disable();
					}
				}
			});

			//disable dragpan on mobile, enable it again when using mouse...
			map.dragPan.disable();
			map.on("mousemove", e => {
				//@ts-ignore
				if(!map.dragPan.isEnabled())
					map.dragPan.enable();
			});

			//@ts-ignore
			map.touchPitch.disable()
			map.on('touchstart', e => {
				var oe = e.originalEvent;
				if (oe && 'touches' in oe) {
					if (oe.touches.length > 1 || this.allowAllInteractions) {
						oe.stopImmediatePropagation();
						map.dragPan.enable();
						//@ts-ignore
						this.$refs.panZoomInfo.hide();
					} else {
						map.dragPan.disable();
					}
				}
			});

			map.on("touchmove", e => {
				const oe = e.originalEvent;
				if (oe && 'touches' in oe) {
					if (oe.touches.length <= 1 && !this.allowAllInteractions && !map.dragPan.isEnabled()) {
						//@ts-ignore
						this.$refs.panZoomInfo.show(true);
					}
				}
			});
		},

		initMap() {

			if(this.initialized)
				return;

			this.zoomTo("all", true)
			this.initialized = true;
			this.progress = 1;
		},

		zoomTo(area:string|Feature<Point>, immediate = false) {

			let cameraOptions:CameraOptions = {};
			if(typeof area != "string") {
				cameraOptions = {
					center: area.geometry!.coordinates as LngLatLike,
					zoom: 15,
				}
			} else {
				let coordinates = (this.trackFeature.geometry as LineString).coordinates;
				let usedFeature = this.trackFeature;
				
				let bounds:LngLatBounds = coordinates.reduce(function(bounds:any, coord:any) {
					return bounds.extend(coord);
				}, new LngLatBounds(coordinates[0] as LngLatLike, coordinates[0] as LngLatLike));

				let padding = {
					left: usedFeature.properties!.paddingLeft || 40,
					right: usedFeature.properties!.paddingRight || 40,
					top: usedFeature.properties!.paddingTop || 100,
					bottom: usedFeature.properties!.paddingBottom || 160,
				}

				//TODO: revisit this: fix for very small screen sizes breaking the map.
				if(padding.top + padding.bottom > window.innerHeight - 30)
					padding.top = padding.bottom = 40;

				if(bounds.isEmpty() || bounds.getNorth() == 0)
					return;
				
				cameraOptions = this.$map.cameraForBounds(bounds, {padding}) as CameraOptions;

			}

			cameraOptions.pitch = 0;
			cameraOptions.bearing = 0;

			if(immediate)
				this.$map.jumpTo(cameraOptions);
			else
				this.$map.flyTo(cameraOptions);
			
			if (typeof area == "string")
				this.currentArea = area;
			else
				this.currentArea = "";
		},

		checkLoaded() {
			if(this.$map.loaded() && this.$map.areTilesLoaded()) {
				this.initMap();
			}
		},

		updateSize() {
			this.elWidth = this.$el.clientWidth;
		},

		setProgress(progress, progressMode) {

			if(this.editMode) {
				this.progress = 1;
				return;
			}

			const disallowedWithLocation = progressMode == "track" && this.locationProgress > -1;

			if(!progressMode || progressMode == "location" || disallowedWithLocation) {
				if(this.locationProgress > -1) {
					progressMode = "location";
					progress = this.locationProgress;
				}
				else {
					progressMode = "";
					progress = 1;
				}
			}

			this.progressMode = progressMode || "";
			this.progress = progress;
		},

		markerClicked(marker) {
			this.zoomTo(marker)
		},

		locateMe() {
			this.currentArea = "";
			this.setProgress(1, "location");
			this.$geolocateControl.trigger();
		}

	},

	watch: {
		trackFeature() {
			loc.updateLocation(undefined, this.trackFeature, this.trackLength);
		},

		locationProgress(p) {
			if(this.progressMode == "" || this.progressMode == "location")
				this.setProgress(p, "location");
		}
	},

	mounted() {

		mapboxgl.accessToken = accessToken;

		let map:Map = new Map({
			container: this.$refs.map as Element,
			style: `mapbox://styles/anderswi/${this.styleId}/?fresh=true`,
			antialias: true,
			attributionControl: false,
		})
		.addControl(new AttributionControl({
			compact: true,
			customAttribution: "<a href='https://www.racemaps.se' target='_blank'>racemaps.se</a>",
		}))
		.addControl(new NavigationControl({showCompass:false}));
		this.$map = map;
		this.initInteractions();

		const geolocate = new GeolocateControl({
			positionOptions: {
				enableHighAccuracy:true,
			},
			fitBoundsOptions: {
				maxZoom: 17,
			},
			trackUserLocation: true,
			//@ts-ignore
			showAccuracyCircle: true
		});
		this.$geolocateControl = geolocate;

		//GEOLOCATE BUTTON

		geolocate.on('geolocate', (evt:GeolocationPosition) => { // eslint-disable-line
			loc.updateLocation(evt, this.trackFeature, this.trackLength);
		});

		//error is GeolocationPositionError, but that fails in ts build...?
		geolocate.on('error', (evt:any) => {
			//TODO: handle other evt.code errors?
			if(evt.code == evt.PERMISSION_DENIED) {
				this.$emit("positionError");
			}
			this.trackingLocation = false;
		})

		geolocate.on('trackuserlocationstart', () => {
			this.trackingLocation = true;
		});

		geolocate.on('trackuserlocationend', () => {
			this.trackingLocation = false;
		});

		checkGeolocationSupport((works) => {
			this.hasGeolocationSupport = works;
		})

		if(!this.editMode)
			map.addControl(geolocate);

		map.on("load", () => {
			//geolocate.trigger();
		})

		// //for testing location tracks
		// map.on("click", evt => {
		// 	const pos:any = {};
		// 	pos.type = "geolocate";
		// 	pos.timestamp = new Date().getTime() + 100;
		// 	pos.coords = {longitude: evt.lngLat.lng, latitude:evt.lngLat.lat, accuracy: 12};
		// 	loc.updateLocation(pos, this.trackFeature, this.trackLength)
		// })

		// HACK FIX FOR CIRCLE RADIUS FLICKERING. (unprojecting 100px instead of 1px)
		//@ts-ignore
		GeolocateControl.prototype._updateCircleRadius = function() {
		//@ts-ignore
			const y = this._map._container.clientHeight / 2;
		//@ts-ignore
			const a = this._map.unproject([0, y]);
		//@ts-ignore
			const b = this._map.unproject([100, y]);
			const metersPerPixel = a.distanceTo(b) / 100;
		//@ts-ignore
			const circleDiameter = Math.ceil(2.0 * this._accuracy / metersPerPixel);
		//@ts-ignore
			this._circleElement.style.width = `${circleDiameter}px`;
		//@ts-ignore
			this._circleElement.style.height = `${circleDiameter}px`;
		}


		map.on('load', this.checkLoaded );

		map.on("movestart", (evt) => {
			if(evt.originalEvent && evt.originalEvent.type != "resize")
				this.currentArea = "";
		});


		map.on("resize", (evt) => {
			if(this.currentArea != "") {
				this.zoomTo(this.currentArea);
			}
			this.updateSize();
		});

		map.on("zoom", (evt) => {
			this.currentZoom = this.$map.getZoom();
		});

		this.updateSize();
		// this.updateTrackColor();
		
		this.progress = 0;

		document.addEventListener("fullscreenchange", (evt) => {
			this.fullscreen = document.fullscreenElement == this.$refs.mapContainer;
			sendResizeEventNextTick();

		});
	},
})
